import * as React from 'react';
import { MotionConfig } from "framer-motion";
import { CursorProvider } from "./CursorProvider.js";

// Layout owns the single <main> landmark for every page. Pages render section
// content only — they must not render their own <main>. Route transitions are
// handled by the View Transitions API (see gatsby-browser.js + global.css),
// not a wrapper component. MotionConfig makes framer-motion animations respect
// the OS "reduce motion" setting.
const Layout = props => {
  return (
    <MotionConfig reducedMotion="user">
      <CursorProvider>
        <main className="page-main">{props.children}</main>
      </CursorProvider>
    </MotionConfig>
  )
}

export default Layout
